import { render, staticRenderFns } from "./pvr.vue?vue&type=template&id=1ff3da69&"
import script from "./pvr.vue?vue&type=script&lang=js&"
export * from "./pvr.vue?vue&type=script&lang=js&"
import style0 from "./pvr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports